import React from "react"
import { Button, Box } from "@mui/material"

import { makeStyles } from "makeStyles"

import Link from "components/i18n/Link"

import { Category } from "@secureo/common/typings/Category"

const useStyles = makeStyles()({
	flexButton: {
		width: "auto",
		border: "1px solid rgba(115, 122, 128, 0.4)",
		borderRadius: 20,
		padding: "5px 8px 5px 8px",
		textTransform: "inherit",
		background: "white",
		transition: "0.3s",
		color: "#505e5f",
	},
})

const ChildCategories = ({ childCategories }: Props) => {
	const { classes } = useStyles()

	return (
		<Box
			mb={-2}
			className="scrollX-no-scrollbar"
			style={{
				display: "flex",
				background: "white",
				flexFlow: "wrap",
				paddingBottom: 14,
				borderBottom: "1px dashed #E3E5E6",
			}}
		>
			{childCategories.map((childCategory) => {
				const { slug, name } = childCategory

				return (
					<Box mr={1} mt={1} mb={0.5} key={slug}>
						<Link href={`/c/${slug}`}>
							<Button className={classes.flexButton}>
								<div style={{ whiteSpace: "nowrap", fontSize: "0.8rem" }}>
									{name}
								</div>
							</Button>
						</Link>
					</Box>
				)
			})}
		</Box>
	)
}

interface Props {
	childCategories: Category["children"]
}

export default ChildCategories
